import { createRouter, whoamiMiddleware } from "@common/router"
import routes from "./routes"
import config from "@/edita.config.js"

const router = createRouter(config, routes)

// Use whoami middleware to do whoami call (check authentication) and then fetch
// static content for the application.
router.beforeEach((to, from, next) => whoamiMiddleware(router.app.$store)(to, from, next))

export default router
export { routes }
